/**
 * Подсказки под текущий экран (agroai-6al.61): вопросы `answers` блоков
 * страницы из каталога ai-surface. Каталог тяжёлый — грузится лениво, когда
 * панель открыта на пустой беседе.
 */

import type { AiRegion } from '../ai-surface/types';

type Catalog = Record<string, AiRegion[]>;

let cached: Promise<Catalog> | null = null;

function loadCatalog(): Promise<Catalog> {
  cached ??= Promise.all([
    import('../ai-surface/catalog/overview'),
    import('../ai-surface/catalog/season'),
    import('../ai-surface/catalog/land'),
    import('../ai-surface/catalog/farms'),
    import('../ai-surface/catalog/cabinet'),
  ]).then((modules) => Object.assign({}, ...modules.map((m) => m.CATALOG)) as Catalog);
  return cached;
}

/** До `limit` вопросов блоков экрана: по одному с блока, затем остальные. */
export async function screenQuestions(pageId: string, limit = 4): Promise<string[]> {
  const catalog = await loadCatalog();
  const regions = catalog[pageId] ?? [];
  const first = regions.map((region) => region.answers[0]).filter((q): q is string => Boolean(q));
  const rest = regions.flatMap((region) => region.answers.slice(1));
  return [...new Set([...first, ...rest])].slice(0, limit);
}
